const gaId = process.env.GA_ID;

// Add gtag.js script
const script = document.createElement('script');
script.async = true;
script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
document.body.appendChild(script);

window.dataLayer = window.dataLayer || [];

// gtag tiene que ser una función "clásica" ya que necesitamos arguments, que es
// lo que espera la librería de gtag en el arreglo `dataLayer`.
// No cambiar por una función flecha!
function gtag() {
  window.dataLayer.push(arguments);
}

export const gTagConfig = opts => gtag('config', gaId, opts);

// custom event parameter UID
let UID;

export const gTagSet = (key, value) => {
  // If setting the user_id we cache it in the module scope so that we can add
  // it as a parameter in future events.
  if (key === 'user_id') {
    UID = value;
  }
  return gtag('set', key, value);
};

// All events will have UID added into event data
export const gTagEvent = (name, data) => gtag('event', name, { ...data, UID });

export const GtagEvent = ({ name, data }) => {
  gTagEvent(name, data);
  return null;
};

// Initialize the GA4 SDK
gtag('js', new Date());

// Config gtag as early as possible, uid is going to be set globally later
gTagConfig({ send_page_view: false });
